import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { getI18n } from 'react-i18next';
import { Tooltip } from 'antd';
import TableHeader from '~/pages/agent/components/agent/tableElements/TableHeader';
import { CellText } from '~/pages/agent/components/agent/tableElements/cells/CellText';
import { useCopy } from '~/hooks/clipboard';
import styled from 'styled-components';

function phoneNumberCell(visibleColumns: any) {
  if (!visibleColumns.includes('phoneNumber')) {
    return null;
  }
  return {
    title: <TableHeader title={getI18n().t('Phone Number', { ns: 'sales' })} />,
    dataIndex: ['phoneNumber'],
    key: 'phoneNumber',
    render: (phoneNumber: any) => <PhoneNumberDisplay phoneNumber={phoneNumber} />,
    width: 140,
  };
}

const PhoneNumberDisplay = ({ phoneNumber }: { phoneNumber?: string }) => {
  const copy = useCopy();

  if (!phoneNumber) return <CellText>-</CellText>;

  return (
    <Tooltip title={`Click to copy: ${phoneNumber}`}>
      <ClickableContainer
        onClick={(e) => {
          void copy(phoneNumber);
          e.preventDefault();
        }}
      >
        <CellText>{phoneNumber}</CellText>
      </ClickableContainer>
    </Tooltip>
  );
};

const ClickableContainer = styled.div`
  cursor: pointer;
  &:hover {
    background-color: #f5f5f5;
    border-radius: 4px;
  }
`;

export default phoneNumberCell;
